import { render, staticRenderFns } from "./RecommenderLinks.vue?vue&type=template&id=435f3f50&"
import script from "./RecommenderLinks.vue?vue&type=script&lang=js&"
export * from "./RecommenderLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports